import _     from 'lodash'
import Model from 'alto-orm/lib/orm/model'

export default class User extends Model
  @onlyAttrs: ['email', 'username', 'password', 'firstName', 'lastName',
               'isActive', 'isStaff', 'isSuperuser', 'id', 'hasPassword']

  @nominativeName: 'uživatel'
  @accusativeName: 'uživatele'

  Object.defineProperty @::, 'fullName', get: -> _.join(_.compact([@firstName, @lastName]), ' ')
  Object.defineProperty @::, 'isStaffOrAdmin', get: -> @isStaff or @isSuperuser
